import { render, staticRenderFns } from "./FilterBySources.vue?vue&type=template&id=88a7e434&scoped=true"
import script from "./FilterBySources.vue?vue&type=script&lang=js"
export * from "./FilterBySources.vue?vue&type=script&lang=js"
import style0 from "./FilterBySources.vue?vue&type=style&index=0&id=88a7e434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a7e434",
  null
  
)

export default component.exports